import { Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { useEffect, useState } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getCountries } from 'state/reducers/global.reducer';
import { getSelectedEntity } from 'state/reducers/customer-accounts.reducers';

export const BeneficiaryBankDetails = () => {
	const t = useAppSelector(selectTranslations);
	const [bankDetailsData, setBankDetailsData] = useState<any>(null);
	const fieldPrefix = 'page.customerAccounts.forms.beneficiaries.bankDetails.';
	const countries = useAppSelector(getCountries);

	const selectedEntity = useAppSelector(getSelectedEntity);

	useEffect(() => {
		if (selectedEntity?.data && countries) {
			const beneficiary = selectedEntity?.data;
			const countryName = countries.filter(
				(country: any) => country.id === parseInt(beneficiary?.bankAccountCountryId)
			)[0];

			setBankDetailsData({
				bankAccountHolderName: beneficiary?.bankAccountHolderName,
				accountNumber: beneficiary?.accountNumber,
				country: countryName?.name,
				commentForUnequalCountries: beneficiary?.commentForUnequalCountries,
			});
		}
	}, [selectedEntity?.data, countries]);

	return (
		<>
			{bankDetailsData && (
				<Stack spacing={2}>
					{Object.keys(bankDetailsData).map((key: any) => {
						const value = bankDetailsData[key];
						return value ? (
							<Stack key={key} spacing={3}>
								<Stack direction="column">
									<Typography variant="subtitleBold">{t(`${fieldPrefix}${key}`)}</Typography>
									<Typography variant="subtitle2">{value}</Typography>
								</Stack>
							</Stack>
						) : null;
					})}
				</Stack>
			)}
		</>
	);
};
